import { ViewChild, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { IndClaimSubmission } from '../../model/ind-claim-submission';
import { AuthenticateClaimSubmitterComponent } from '../authenticate-claim-submitter/authenticate-claim-submitter.component';
import { OnlineDocumentUploadIndComponent } from '../online-document-upload-ind/online-document-upload-ind.component';
import { ValidatePolicyDataComponent } from '../validate-policy-data/validate-policy-data.component';

@Component({
  selector: 'app-online-claim-submission-ind',
  templateUrl: './online-claim-submission-ind.component.html',
  styleUrls: ['./online-claim-submission-ind.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OnlineClaimSubmissionIndComponent implements OnInit {

  constructor() { }

  submissionData: IndClaimSubmission = new IndClaimSubmission();
  selectedTab = 0;
  resetDefault: boolean = true;

  @ViewChild(AuthenticateClaimSubmitterComponent, { static: true }) authComponent: AuthenticateClaimSubmitterComponent;
  @ViewChild(ValidatePolicyDataComponent, { static: true }) vpdComponent: ValidatePolicyDataComponent;
  @ViewChild(OnlineDocumentUploadIndComponent, { static: true }) docUpComponent: OnlineDocumentUploadIndComponent;

  tabs = [
    {
      name: "Authentication",
      disabled: false
    },
    {
      name: "Validating Policy Data",
      disabled: true
    },
    {
      name: "Document Upload",
      disabled: true
    }
  ];

  ngOnInit(): void {
  }

  tabChanged(tabIdx: number): void {
    for (let i = 0; i < this.tabs.length; i++) {
      if (i == tabIdx) {
        this.tabs[i].disabled = false;
      } else {
        this.tabs[i].disabled = true;
      }
    }
    this.selectedTab = tabIdx;
  }

  onValidOTP(data: any) {
    this.resetDefault = false;
    this.submissionData.claimSubmitterName = data.claimSubmitterName;
    this.submissionData.claimSubmitterMobileNumber = data.claimSubmitterMobileNumber;
    this.submissionData.indClaimSubmitterRole = data.indClaimSubmitterRole;
    this.submissionData.browserId = data.browserId;
    this.tabChanged(1);
  }

  onValidPolicyData(data: any) {

    this.submissionData.policyNumber = data.policyNumber;
    this.submissionData.yearOfBirthPolicyOwner = data.birthYear;
    this.tabChanged(2);
  }

  resetToDefaults(data: any) {
    this.tabChanged(0);
    this.resetAllChildComponentForms();
  }

  onResetMobileNumber() {
    this.submissionData = new IndClaimSubmission();
    this.authComponent.resetSettings();
    this.vpdComponent.resetFormSettings();
    this.docUpComponent.resetFormSetting();
  }

  prevTab() {
    if (this.selectedTab != 0) {
      this.tabChanged(this.selectedTab - 1);
    }
  }

  nextTab() {
    if (this.selectedTab != 2) {
      this.tabChanged(this.selectedTab + 1);
    }
  }

  resetChildComponentForms(data) {
    if (data && data.isResettable) {
      this.resetToDefaults(data);
      this.tabChanged(0);
    }

  }

  resetAllChildComponentForms() {
    this.submissionData = new IndClaimSubmission();
    this.authComponent.resetAuthForm();
    this.vpdComponent.resetFormSettings();
    this.docUpComponent.resetFormSetting();
  }
}
